import React from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import LoginForm from "../components/login/LoginForm";
import "../styles/login.css";

export default function AdminLoginPage() {
  return (
    <section className="admin-page">
      <Navbar />

      <div className="admin-login-wrapper">
        <div className="admin-login-content">
          <div className="admin-login-header">
            <h1>Admin Access</h1>
            <p>Secure login for Prodicus administrators</p>
          </div>
          <LoginForm
            role="admin"
            title="Admin Login"
            subtext="For Prodicus administrators and developers."
          />
        </div>
      </div>

      <Footer />
    </section>
  );
}
